import { useList, useDetail, useCreate, useUpdate, useDelete, usePartialUpdate, useAction } from "@inmagik/react-crud"
import { Paratesto } from "../types"
import { API_URL } from "../constants"

export function useParatestiList(params: Record<string, string> = {}) {
  return useList<Paratesto>(`${API_URL}/admin/paratesti`, {
    query: params,
  })
}

export function useParatesto(id: number | undefined) {
  return useDetail<Paratesto>(`${API_URL}/admin/paratesti`, id?.toString())
}

export function useParatestoCreate() {
  return useCreate<Paratesto>(`${API_URL}/admin/paratesti`)
}

export function useParatestoUpdate() {
  return useUpdate<Paratesto>(`${API_URL}/admin/paratesti`)
}

export function useParatestoDelete() {
  return useDelete<Paratesto>(`${API_URL}/admin/paratesti`)
}

export function useParatestoPartialUpdate() {
  return usePartialUpdate<Paratesto>(`${API_URL}/admin/paratesti`)
}

export function useParatestoOrderUpdate(params: Record<string, string> = {}) {
  return useAction(`${API_URL}/admin/paratesti/change-order?${new URLSearchParams(params).toString()}`, {
    method: "GET",
  })
}